<template>
  <main id="main">
    <header class="header_page fadeIn mb-4">
        <p id="title_header_page" class="mr-3 bold">{{ t('teaching_grades') }}</p>
        <img src="@/assets/imgs/back.svg" class="icon-size-3" alt="" @click="$router.go(-1)">
    </header>

    <div v-if="loading" class="d-flex justify-content-center align-items-center mt-5">
        <p>{{ t('loading') }}</p>
    </div>

    <div v-else class="w-100 p-3 d-flex flex-column row-gap-5">
        
        <div>
            <p class="font_normal bold mb-3 text_color_theme">{{ t('you_teach_lessons') }}:</p>
            <div v-if="lessons.length === 0" class="text_color_gray font_small">{{ t('empty_list') }}</div>
            <div v-else class="d-flex flex-wrap justify-content-start gap-3">
                <span v-for="lesson in lessons" :key="lesson.lesson_id" class="bg-white px-4 py-3 rounded-pill shadow bold">
                    {{ lesson.title }}
                </span>
            </div>
        </div>

        <div>
            <p class="font_normal bold mb-3 text_color_theme">{{ t('you_teach_grades') }}:</p>
            <div v-if="grades.length === 0" class="text_color_gray font_small">{{ t('empty_list') }}</div>
            <div v-else class="d-flex flex-wrap justify-content-start gap-3">
                <div v-for="grade in grades" :key="grade.grade_id" class="bg-white px-4 py-3 rounded-pill shadow d-flex align-items-center gap-2">
                    <span class="bold">{{ grade.grade_title }}</span>
                    <span class="badge bg_light_theme text_white rounded-pill px-2 py-1 font_tiny">{{ grade.students_count }}</span>
                </div>
            </div>
        </div>

        <div class="mt-4 bg_white p-3 rounded-4 shadow border_dashed d-flex justify-content-around">
            <div class="text-center">
                <p class="font_large bold text_color_theme">{{ lessonsCount }}</p>
                <p class="font_small text_color_gray">{{ t('lesson_count') }}</p>
            </div>
            <div style="width: 1px; background: #eee;"></div>
            <div class="text-center">
                <p class="font_large bold text_color_theme">{{ gradesCount }}</p>
                <p class="font_small text_color_gray">{{ t('grade_count') }}</p>
            </div>
        </div>

    </div>
  </main>
</template>

<script>
import apiClient, { createFormData } from '@/services/api'

export default {
  name: 'TeacherStatus',
  data() {
    return {
        loading: false,
        lessons: [],
        grades: [],
        lessonsCount: 0,
        gradesCount: 0
    }
  },
  mounted() {
    this.fetchOverview();
  },
  methods: {
    async fetchOverview() {
        this.loading = true;
        try {
            const userId = localStorage.getItem('user_id');
            const formData = createFormData({
                teacher_id: userId
            });

            const response = await apiClient.post('/teacher/teaching_overview', formData);

            if (response.data.status === 'ok' && response.data.data) {
                const data = response.data.data;
                this.lessons = data.lessons || [];
                this.grades = data.grades || [];
                this.lessonsCount = data.lessons_count || 0;
                this.gradesCount = data.grades_count || 0;
            }
        } catch (error) {
            console.error(error);
        } finally {
            this.loading = false;
        }
    }
  }
}
</script>

<style scoped>
.text_color_theme {
    color: #4A00E0;
}
.bg_light_theme {
    background-color: #4A00E0;
}
.font_tiny {
    font-size: 0.75rem;
}
.border_dashed {
    border: 1px dashed #ccc;
}
.text_color_gray {
    color: #888;
}
</style>